import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addUser, updateUser } from "src/store/user";
import { addUserProfile, updateUserProfile } from "src/store/profile";
import { getMcode } from "src/store/mcode";
import { ValidationMessages } from "src/components/common/ValidationMessage";
import { resetStateIdele } from "src/store/user";

const UserConfirm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const ShowProfileScreen = location.state?.ShowProfileScreen || false;
  const { formData } = location.state || {};
  const statusCd = useSelector((state) => state.mcode.data.status);
  const authCd = useSelector((state) => state.mcode.data.auth);
  const departmentCd = useSelector((state) => state.mcode.data.department);
  const userRoleCd = useSelector((state) => state.mcode.data.role);
  const bloodGroup = useSelector((state) => state.mcode.data.bloodgroup);
  const programmingLanguage = useSelector(
    (state) => state.mcode.data.programminglanguage
  );
  const workingHoursCd = useSelector(
    (state) => state.mcode.data.workinghourscd
  );
  const user = useSelector((state) => state.user);
  const authRole = useSelector((state) => state.mcode.data.role);
  
  const [validationMessages, setValidationMessages] = useState([]);

  const clickBackBtn = () => {
    if (formData.id) {
      navigate(`/userEdit/${formData.id}`, { state: { formData: formData } });
    } else {
      navigate("/userinput", {
        state: { formData: formData, isInputConfirmScreen: true },
      });
    }
  };

  const clickRegBtn = () => {
    // Split user data and profile data
    const userInfo = {
      id: formData.id,
      login_id: formData.login_id,
      password: formData.password,
      name: formData.name,
      email: formData.email,
      status_cd: parseInt(formData.status_cd),
      auth_cd: parseInt(formData.auth_cd),
      department_cd: parseInt(formData.department_cd),
      user_role_cd: parseInt(formData.user_role_cd),
      working_hours_cd: parseInt(formData.working_hours_cd),
      hire_date: formData.hire_date,
      retirement_date: formData.retirement_date,
      icon_num: formData.icon_num,
      changePassword: formData.changePassword,
    };

    const profileData = {
      user_id: formData.id, // This will be null for new users
      date_of_birth: formData.date_of_birth,
      blood_group_cd: formData.blood_group_cd,
      hobbies: formData.hobbies,
      education_history: formData.education_history,
      programming_languages_cd: formData.programming_languages_cd,
    };

    if (formData.id) {
      // Update user first
      dispatch(updateUser(userInfo))
        .then((response) => {
          if (response.payload.errors) {
            setValidationMessages(response.payload.errors);
            return;
          }
          if (response.payload?.status === 500) {
            alert(response.payload.message);
            return;
          }

          // After successful user update, update profile
          dispatch(updateUserProfile(profileData))
            .then((profileResponse) => {
              if (profileResponse.payload.errors) {
                setValidationMessages(profileResponse.payload.errors);
              }
              if (profileResponse.payload?.status === 500) {
                alert(profileResponse.payload.message);
              }
            })
            .catch((error) => {
              setValidationMessages([error.message]);
            });
        })
        .catch((error) => {
          setValidationMessages([error.message]);
        });
    } else {
      // Create new user first
      dispatch(addUser(userInfo))
        .then((response) => {
          if (response.payload.errors) {
            setValidationMessages(response.payload.errors);
            return;
          }
          if (response.payload?.status === 500) {
            alert(response.payload.message);
            return;
          }

          // If user creation successful, create profile with new user_id
          if (response.payload?.data?.id) {
            const profileDataWithUserId = {
              ...profileData,
              user_id: response.payload.data.id,
            };
            // Create profile for new user
            dispatch(addUserProfile(profileDataWithUserId))
              .then((profileResponse) => {
                if (profileResponse.payload.errors) {
                  setValidationMessages(profileResponse.payload.errors);
                }
                if (profileResponse.payload?.status === 500) {
                  alert(profileResponse.payload.message);
                }
              })
              .catch((error) => {
                setValidationMessages([error.message]);
              });
          }
        })
        .catch((error) => {
          setValidationMessages([error.message]);
        });
    }
  };
  useEffect(() => {
    dispatch(
      getMcode({
        section_cd:
          "jobtype,department,position,worklocation,status,auth,workinghourscd,usertype,bloodgroup,programminglanguage,role",
      })
    );
  }, []);

  const clickUserListBtn = () => {
    navigate("/userList");
  };

  useEffect(() => {
    if (user.status === "succeeded") {
      resetStateIdele();
      clickUserListBtn();
    } else {
      setValidationMessages(user.errors);
    }
  }, [user.status, user.errors, validationMessages]);

  return (
    <div className="wrapper">
      {validationMessages && validationMessages.length > 0 && (
        <div style={{ background: "#ffe4e2" }}>
          <ValidationMessages
            messages={validationMessages}
            onClose={() => setValidationMessages([])}
          />
        </div>
      )}
      <section className="container-fluid contents-top">
        <div className="text-right">
          <button
            type="button"
            className="btn btn-default"
            onClick={clickUserListBtn}
          >
            <span
              className="glyphicon glyphicon-chevron-left"
              aria-hidden="true"
            ></span>
            Back to List
          </button>
        </div>

        <div className="" style={{ width: "90%", margin: "0 auto" }}>
          {formData.id ? (
            <h3 className="title-style01">Modify User Registration</h3>
          ) : (
            <h3 className="title-style01">New User Registration</h3>
          )}
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Icon * </label>
            <div className="col-sm-9">
              <span
                id="user-icon-detail"
                className={`statusicon sta-icon${formData?.icon_num}`}
              ></span>
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">LoginID *</label>
            <div className="col-sm-9 tooltip-container">
              <p
                className="form-control confirm_style break-word"
                title={formData?.login_id}
              >
                {formData?.login_id.length > 30
                  ? `${formData?.login_id.slice(0, 30)}...`
                  : formData?.login_id}
              </p>
              <span className="tooltip">{formData?.login_id}</span>
            </div>
          </div>
          {formData.password && (
            <div className="form-group div-height">
              <label className="col-sm-3 control-label">Password *</label>
              <div className="col-sm-9">
                <p className="form-control confirm_style ">
                  *******************
                </p>
              </div>
            </div>
          )}
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Name *</label>
            <div className="col-sm-9 tooltip-container">
              <p
                className="form-control confirm_style break-word"
                title={formData?.name}
              >
                {formData?.name.length > 30
                  ? `${formData?.name.slice(0, 30)}...`
                  : formData?.name}
              </p>
              <span className="tooltip">{formData?.name}</span>
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label"> Mail Address *</label>
            <div className="col-sm-9 tooltip-container">
              <p
                className="form-control confirm_style break-word"
                title={formData?.email}
              >
                {formData?.email.length > 30
                  ? `${formData?.email.slice(0, 30)}...`
                  : formData?.email}
              </p>
              <span className="tooltip">{formData?.email}</span>
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Status *</label>
            <div className="col-sm-9">
              {statusCd &&
                statusCd.map((status_cd) =>
                  formData?.status_cd === status_cd.cd ? (
                    <p
                      key={status_cd.cd}
                      className="form-control confirm_style"
                    >
                      {status_cd.code_value1}
                    </p>
                  ) : null
                )}
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Authority *</label>
            <div className="col-sm-9">
              {authCd &&
                authCd.map((auth_cd) =>
                  formData?.auth_cd === auth_cd.cd ? (
                    <p key={auth_cd.cd} className="form-control confirm_style">
                      {auth_cd.code_value1}
                    </p>
                  ) : null
                )}
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Department * </label>
            <div className="col-sm-9">
              {departmentCd &&
                departmentCd.map((department_cd) =>
                  formData?.department_cd === department_cd.cd ? (
                    <p
                      key={department_cd.cd}
                      className="form-control confirm_style"
                    >
                      {department_cd.code_value1}
                    </p>
                  ) : null
                )}
            </div>
          </div>
           <div className="form-group div-height">
            <label className="col-sm-3 control-label">Role * </label>
            <div className="col-sm-9">
              {userRoleCd &&
                userRoleCd.map((userRole_cd) =>
                   formData?.user_role_cd === userRole_cd.cd ? (
                    <p
                      key={userRole_cd.cd}
                      className="form-control confirm_style"
                    >
                      {userRole_cd.code_value1}
                    </p>
                  ) : null
                )}
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Core Time *</label>
            <div className="col-sm-9">
              {workingHoursCd &&
                workingHoursCd.map((working_hours_cd) =>
                  formData?.working_hours_cd === working_hours_cd.cd ? (
                    <p
                      key={working_hours_cd.cd}
                      className="form-control confirm_style"
                    >
                      {working_hours_cd.code_value1}
                    </p>
                  ) : null
                )}
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">Hire Date * </label>
            <div className="col-sm-9">
              <p className="form-control confirm_style">
                {formData?.hire_date ? formData?.hire_date : "N/A"}
              </p>
            </div>
          </div>
          <div className="form-group div-height">
            <label className="col-sm-3 control-label">
              Retirement date &nbsp;&nbsp;
            </label>
            <div className="col-sm-9">
              <p className="form-control confirm_style">
                {formData?.retirement_date ? formData?.retirement_date : "N/A"}
              </p>
            </div>
          </div>
          {(ShowProfileScreen || formData?.id == !false) && (
            <div className="user-profile-section">
              <h3 className="title-style01">User Profile</h3>

              <div className="form-group div-height">
                <label className="col-sm-3 control-label">Date of Birth</label>
                <div className="col-sm-9">
                  <p className="form-control confirm_style">
                    {formData?.date_of_birth || "N/A"}
                  </p>
                </div>
              </div>

              <div className="form-group div-height">
                <label className="col-sm-3 control-label">Blood Group </label>
                <div className="col-sm-9">
                  {formData?.blood_group_cd ? (
                    bloodGroup?.map((blood_group_cd) =>
                      formData.blood_group_cd === blood_group_cd.cd ? (
                        <p
                          key={blood_group_cd.cd}
                          className="form-control confirm_style"
                        >
                          {blood_group_cd.code_value1}
                        </p>
                      ) : null
                    )
                  ) : (
                    <p className="form-control confirm_style">N/A</p>
                  )}
                </div>
              </div>

              <div className="form-group div-height">
                <label className="col-sm-3 control-label">Hobbies </label>
                <div className="col-sm-9">
                  <p
                    className="form-control confirm_style break-word"
                    title={formData?.hobbies}
                  >
                    {formData?.hobbies?.length > 30
                      ? `${formData?.hobbies.slice(0, 30)}...`
                      : formData?.hobbies || "N/A"}
                  </p>
                  <span className="tooltip">{formData?.hobbies}</span>
                </div>
              </div>

              <div className="form-group div-height">
                <label className="col-sm-3 control-label">
                  Education History
                </label>
                <div className="col-sm-9">
                  <p
                    className="form-control confirm_style break-word"
                    title={formData?.education_history}
                  >
                    {formData?.education_history?.length > 30
                      ? `${formData?.education_history.slice(0, 30)}...`
                      : formData?.education_history || "N/A"}
                  </p>
                  <span className="tooltip">{formData?.education_history}</span>
                </div>
              </div>

              <div className="form-group div-height">
                <label className="col-sm-3 control-label">
                  Known Languages
                </label>
                <div className="col-sm-9">
                  <p className="form-control confirm_style">
                    {(() => {
                      let codes = [];
                      try {
                        const raw = formData?.programming_languages_cd;
                        codes =
                          typeof raw === "string"
                            ? JSON.parse(raw)
                            : Array.isArray(raw)
                            ? raw
                            : [];
                      } catch (e) {
                        console.error(
                          "Failed to parse programming_languages_cd",
                          e
                        );
                      }

                      return Array.isArray(programmingLanguage)
                        ? programmingLanguage
                            .filter((lang) =>
                              codes.includes(lang.cd.toString())
                            )
                            .map((lang) => lang.code_value1)
                            .join(", ")
                        : "N/A";
                    })()}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="form-group text-center">
            <button
              type="button"
              onClick={clickBackBtn}
              className="btn btn-default btn-lg jq-re_edit_data"
            >
              Back
            </button>
            <button
              type="button"
              onClick={clickRegBtn}
              className="btn btn-success btn-lg jq-regester_data"
            >
              {formData.id ? "Update" : "Register"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserConfirm;
